import { deleteAllFilesInCloudStorageFolder } from "./deleteAllFilesInCloudStorageFolder";
import { getBaseStoragePathWithoutFilename } from "../cloudStorageFilenameUtilities";

/**
 * @function deleteCloudStorageFilesForBaseStoragePath Deletes the Cloud Storage files for a baseStoragePath
 * @param {string} baseStoragePath The base storage path of the file in CloudStorage, including the filename, but without server name, security adornments, etc.
 * @returns {Promise<void>} Returns a promise with void value, providing asynchronous functionality.
 */
export function deleteCloudStorageFilesForBaseStoragePath(baseStoragePath: string): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get the baseStoragePath without the filename segment at the end (resulting in a logical folder pathname)
      const cloudStorageFolderPathname: string = getBaseStoragePathWithoutFilename(baseStoragePath);

      // call method to delete all files in the logical folder pathname
      await deleteAllFilesInCloudStorageFolder(cloudStorageFolderPathname);

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}